import { css } from '@emotion/react';
import { responsive } from '@wci-tech/core-ui';

import type { ITheme } from '@wci-tech/core-ui';

const DESKTOP_LAYOUT_WIDTH = 2220;
const DESKTOP_SIDE_GUTTER = 64;

type HorizontalSpacingOptions = {
  paddingLeft?: {
    default: string;
    md: string;
    lg: string;
  };
  paddingRight?: {
    default: string;
    md: string;
    lg: string;
  };
};

export const getDesktopContentMaxWidth = (theme: ITheme) =>
  `calc(${theme.spacing.get(DESKTOP_LAYOUT_WIDTH)} - (${theme.spacing.get(DESKTOP_SIDE_GUTTER)} * 2))`;

export const getSharedDesktopContainer = (theme: ITheme) =>
  responsive.create({
    maxWidth: {
      default: '100%',
      md: '100%',
      lg: getDesktopContentMaxWidth(theme),
    },
  });

export const getContainerStyles = (theme: ITheme, options?: HorizontalSpacingOptions) => css`
  width: 100%;

  ${getSharedDesktopContainer(theme)};

  ${responsive.create({
    paddingLeft: {
      default: options?.paddingLeft?.default ?? theme.spacing.get(16),
      md: options?.paddingLeft?.md ?? theme.spacing.get(24),
      lg: options?.paddingLeft?.lg ?? theme.spacing.get(64),
    },
    paddingRight: {
      default: options?.paddingRight?.default ?? theme.spacing.get(16),
      md: options?.paddingRight?.md ?? theme.spacing.get(24),
      lg: options?.paddingRight?.lg ?? theme.spacing.get(64),
    },
  })}
`;

export const getStickyContainerStyles = (theme: ITheme) => css`
  width: 100%;
  margin: 0 auto;

  ${getSharedDesktopContainer(theme)};
`;
